import React from 'react';
import { Card, Collapse } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import { COMPANY_PACKING_DAYS_GUARANTEE, COMPANY_WORKING_HOURS } from '../../../config';

import PageTitle from '../../../components/PageTitle';
import ShippingAddress from '../../../components/ShippingAddress';

import './index.css';

const { Panel } = Collapse;

const faq = [
  {
    question: '如何参加拼邮？',
    answer: (
      <p>
        新手可以查看 <Link to="/tutorial">转运教程</Link>
      </p>
    ),
  },
  {
    question: '什么时候截团？',
    answer: (
      <p>
        大家要凑够重量才能截团，团列表可以看到入库实时重量总和，到达重量后会开启自动截团倒计时，根据团设置通常是0-72小时，具体设置可以在团详情页查看。截团时还没入库的包裹都无法跟团发走，会被系统自动添加到新开的同名团，后续可以修改包裹加到别的团。
      </p>
    ),
  },
  {
    question: '什么时候预报包裹？',
    answer: (
      <p>
        卖家一发货有了国内的快递单号，就可以在我的包裹页面预报包裹，预报的时候可以选直邮也可以选拼邮团。但也可以不预报，只要包裹上会员号正确，不论有没有预报，到了仓库，都会自动绑定到你。预报的好处是可以提前参团以及填物品信息，没有预报也没关系，入库后默认是直邮类型，可以入库后再修改包裹、选择拼邮团。有时候预报晚了，包裹可能已经入库了（类型默认是直邮），这种情况下就不需要再预报了，直接修改包裹选择拼邮团就行。
      </p>
    ),
  },
  {
    question: '包裹入库实重是包括外包装的吗？',
    answer: <p>是的，是快递签收后原封不动称的实际重量(非体积重)。</p>,
  },
  {
    question: '包裹入库后我需要做什么？',
    answer: (
      <p>
        如果是预报了的包裹，已经选了拼邮团的，那么包裹入库后什么都不用做，等拼邮团截团了，打包好了客服会在微信群通知大家付款。如果是没有预报的包裹，入库时默认是直邮类型，入库后你可以修改包裹加到拼邮团里。需要直邮的话，可以在我的包裹页面选中多个已入库的包裹，点直邮申请打包。
      </p>
    ),
  },
  {
    question: '截团时包裹还没入库怎么办？',
    answer: (
      <p>
        截团时还没入库的包裹都无法跟团发走，但会被系统自动添加到新开的同名团，后续可以修改包裹加到别的团。
      </p>
    ),
  },
  {
    question: '什么时候付款？',
    answer: (
      <p>
        不论拼邮还是直邮，生成订单后(拼邮截团后自动生成订单)，仓库通常会在 {COMPANY_PACKING_DAYS_GUARANTEE}
        个工作日内完成打包，打包完会先尽快发出，运费信息后续才会录入系统。出了运费后会通过系统通知(页面右上角的信封图标)告知大家付款，可以在我的订单里查看运费后支付宝或微信转账给客服。
      </p>
    ),
  },
  {
    question: '如何直邮包裹？',
    answer: (
      <p>
        新手可以查看 <Link to="/tutorial">转运教程</Link>
      </p>
    ),
  },
  {
    question: '仓库地址是什么？',
    answer: (
      <div>
        <p>电商网站下单或让家人邮寄包裹至我们仓库，地址格式如下(单击每行即可复制)：</p>
        <ShippingAddress />
      </div>
    ),
  },
  {
    question: '拼邮和直邮的区别？',
    answer: (
      <p>
        拼邮和直邮相同重量、相同线路收费是一样的，只不过拼邮会把整个团的包裹一起寄到团长家，到货后需要到团长家取，直邮可以直接寄到你自己的家。个人包裹重量比较少的情况下，寄直邮价格会相对较高（大部分线路有首重或最低重量要求），跟大家一起拼既可以享受便宜的运费，又不需要绞尽脑汁凑齐重量。但如果你自己的包裹加起来本身已经足够重了，完全可以选择直邮，在包裹页面勾选多个包裹申请打包即可。
      </p>
    ),
  },
  {
    question: '敏感团只能寄食品吗？',
    answer: (
      <p>
        不是的，敏感线路可以寄食品也可以寄很多普货线路不能寄的东西，是相较于普货更为宽松的线路。但也不是所有食品都可以，详情请参考{' '}
        <Link to="/contraband">这里</Link>
      </p>
    ),
  },
  {
    question: '拼邮怎么收费？',
    answer: (
      <p>
        拼邮的收费在 <Link to="/groups">团列表</Link>{' '}
        最上面有说明，点进去拼邮团详情也可以看到。如果没有的话可以咨询客服。{' '}
      </p>
    ),
  },
  {
    question: '仓库会合并包裹吗？会拆除包装吗？',
    answer: (
      <p>
        不论拼邮还是直邮，仓库默认都会免费替你拆掉每个包裹原来的快递包装，尽量为你减少运费。对于需要原包装或者易变形、易碎的物品请在包裹备注里注明不需要拆包装。拼邮的包裹仓库会把每个人的所有包裹尽量和合并成一包，太多的话可能会分成几包。取货的时候只需要找自己的那一包/几包就行。拼邮的箱号信息可以从我的订单{' '}
        {'>'} 拼邮子订单 {'>'} 拼邮团链接里查看拼邮主订单的仓库备注。
      </p>
    ),
  },
  {
    question: '直邮怎么收费？',
    answer: (
      <p>
        相同重量、相同线路的情况下，直邮和拼邮收取同样的运费，但拼邮通常最低重量限制较高，很多线路其实有针对低重量的报价，详情可以咨询客服。
      </p>
    ),
  },
  {
    question: '直邮可以合并多个包裹吗？',
    answer: (
      <p>
        可以的，在我的包裹页面可以勾选多个直邮包裹申请打包，不限于一个包裹。直邮只是相对于拼邮来说是直接邮寄到你自己家，不是只能邮寄单个包裹的意思。
      </p>
    ),
  },
  {
    question: '包裹一定要预报吗？',
    answer: (
      <p>
        可以不用预报。只要包裹上会员号正确，不论有没有预报，到了仓库，都会自动绑定到你。预报的好处是可以提前参团以及填物品信息，没有预报也没关系，入库后默认是直邮类型，可以入库后再修改包裹、选择拼邮团。
      </p>
    ),
  },
  {
    question: '没有预报的包裹为什么会出现在包裹列表？',
    answer: (
      <p>
        有几种情况：
        <br />
        1.
        卖家拆分包裹发货（或单独发了赠品）。淘宝或其他网站买的东西，有时候卖家会拆分多个包裹发货但只提供了一个单号。只要包裹到了仓库，上面写着你的会员号，不论有没有预报，都会自动绑定到你，预报的好处是可以提前参团以及填物品信息，没有预报也没关系，入库后默认是直邮类型，可以入库后再修改包裹、选择拼邮团。所以你可以私信客服让他帮你确认一下包裹上面是不是你的会员号，是的话可以让他帮你拆开拍照看看是什么，与此同时也留意下最近买的东西，问问卖家是不是拆分包裹发货了。
        <br />
        2. 还没来得及预报，包裹就被仓库签收并入库了。可以检查下单号是不是还没预报的包裹。 <br />
        3. 有非常小的几率是入库时绑定错了人，需要私信客服找到包裹来确认。
      </p>
    ),
  },
  {
    question: '不是我的包裹为什么会出现在包裹列表？',
    answer: (
      <p>
        有几种情况：
        <br />
        1.
        卖家拆分包裹发货（或单独发了赠品）。淘宝或其他网站买的东西，有时候卖家会拆分多个包裹发货但只提供了一个单号。只要包裹到了仓库，上面写着你的会员号，不论有没有预报，都会自动绑定到你，预报的好处是可以提前参团以及填物品信息，没有预报也没关系，入库后默认是直邮类型，可以入库后再修改包裹、选择拼邮团。所以你可以私信客服让他帮你确认一下包裹上面是不是你的会员号，是的话可以让他帮你拆开拍照看看是什么，与此同时也留意下最近买的东西，问问卖家是不是拆分包裹发货了。
        <br />
        2. 还没来得及预报，包裹就被仓库签收并入库了。可以检查下单号是不是还没预报的包裹。 <br />
        3. 有非常小的几率是入库时绑定错了人，需要私信客服找到包裹来确认。
      </p>
    ),
  },
  {
    question: '团名称前面的日期是什么意思？',
    answer: <p>为了便于区分不同批次的团，截团后团名会自动加上截团日期前缀。正在开的团没有前缀。</p>,
  },
  {
    question: '每次打包完不能寄的东西如何处理？',
    answer: (
      <p>
        1.
        如果是整个包裹都不能寄，仓库会把包裹移出拼邮订单和拼邮团，然后包裹状态就恢复已入库了（类型是直邮），什么渠道都不能发的东西可以自己申请直邮打包
        - 选转寄国内，能发的可以加入别的拼邮团
        <br />
        2.
        如果是包裹内一部分东西不能寄，仓库会在系统里对包裹进行拆分，比如里面电动牙刷被拿出来了，原包裹运单号是
        SF12345678，被拆分的包裹会变成
        SF12345678/1，好几个东西的话就会是SF12345678/2，以此类推，然后被拆分出来的新包裹会有自己的重量，状态也都是已入库（类型是直邮），大家就可以根据
        1 中的方法选择变成直邮转寄国内，或是加入别的拼邮团
      </p>
    ),
  },
  {
    question: '拼邮截团后多久能打包好/发货？',
    answer: (
      <p>
        拼邮截团后仓库通常会在 {COMPANY_PACKING_DAYS_GUARANTEE} 个工作日内完成打包，然后通知你付款，付款后会在 2
        个工作日内发出。仓库正常工作时间为{COMPANY_WORKING_HOURS}。遇到国内双十一快递爆仓的情况，打包时间可能会受到影响。
      </p>
    ),
  },
  {
    question: '直邮提交订单后多久能打包好/发货？',
    answer: (
      <p>
        直邮提交订单后，仓库通常会在 {COMPANY_PACKING_DAYS_GUARANTEE} 个工作日内完成打包，然后通知你付款，付款后会在 2
        个工作日内发出。仓库正常工作时间为{COMPANY_WORKING_HOURS}。遇到国内双十一快递爆仓的情况，打包时间可能会受到影响。
      </p>
    ),
  },
  {
    question: '包裹从仓库发出后如何查询物流？',
    answer: (
      <p>
        包裹发出后通常需要几天后才能在我的订单页面看到跟踪号，对于海运普货，由于跟踪号属于尾程派送的公司(UPS或Fedex)，因此在包裹到达美国且被尾程派送公司提货之前物流也不会更新。
      </p>
    ),
  },
  {
    question: '如何查看/支付运费？',
    answer: (
      <p>
        打包完后，可以在我的订单中查看运费信息，运费可以通过微信、支付宝转账给客服，或者淘宝拍单，收款账号请微信联系客服获取，转账时复制订单页面的订单号，写在转账备注中方便客服核对。
      </p>
    ),
  },
  {
    question: '仓库周末/节假日可以收货吗？',
    answer: (
      <p>
        仓库正常工作时间为{COMPANY_WORKING_HOURS}。不过在工作时间以外或法定节假日派送的包裹也不需要担心，上班后都可以正常入库。
      </p>
    ),
  },
  {
    question: '物流信息显示包裹被签收后多久可以入库？',
    answer: (
      <p>
        仓库每天会集中在一段时间内入库，因此包裹被签收后可能不会马上入库，通常会在当日或者次日完成入库，一般不超过
        {COMPANY_PACKING_DAYS_GUARANTEE} 个工作日。若是超过 {COMPANY_PACKING_DAYS_GUARANTEE} 个工作日还未入库，可能是地址有误或者派送出错，请及时联系客服处理。
      </p>
    ),
  },
  {
    question: '什么东西能寄什么东西不能寄？',
    answer: (
      <p>
        每条线路不一样，可以看看 <Link to="/contraband">这里</Link>
      </p>
    ),
  },
  {
    question: '体积重怎么算？',
    answer: (
      <p>
        每条线路不一样，可以看看 <Link to="/contraband">这里</Link>
      </p>
    ),
  },
  {
    question: '想拼邮但我附近没有团怎么办？',
    answer: (
      <p>
        任何人都可以创建新的拼邮团，<Link to="/groups">拼邮团列表页面</Link>{' '}
        点右上角加号即可创建。为了更快地凑满拼邮重量，可以拉住在附近的小伙伴一起来拼。
      </p>
    ),
  },
];

function FAQ() {
  const location = useLocation();
  const hash = location?.hash?.replace('#', '');
  return (
    <div className="FAQ">
      <PageTitle>常见问题</PageTitle>

      <Card bordered={false}>
        <Collapse ghost defaultActiveKey={hash}>
          {faq.map((item, index) => (
            <Panel
              header={
                <a href={`#${index}`} id={index.toString()}>
                  <span style={{ color: 'rgba(0,0,0,.85)' }}>{item.question}</span>
                </a>
              }
              key={index}
            >
              {item.answer}
            </Panel>
          ))}
        </Collapse>
      </Card>
    </div>
  );
}

export default FAQ;
